import { useState } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { TrustBar } from "@/components/site/TrustBar";
import { HowItWorks } from "@/components/site/HowItWorks";
import { OffersShowcase } from "@/components/site/OffersShowcase";
import { Gallery } from "@/components/site/Gallery";
import { LeadCapture } from "@/components/site/LeadCapture";
import { FounderNote } from "@/components/site/FounderNote";
import { FAQ } from "@/components/site/FAQ";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  const [leadContext, setLeadContext] = useState({ interest: "", offerId: "", offerTitle: "" });

  const handleRequest = (ctx) =>
    setLeadContext({ interest: ctx.interest || "", offerId: ctx.offerId || "", offerTitle: ctx.offerTitle || "" });

  return (
    <div data-testid="home-page" className="bg-sand min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <HowItWorks />
        <OffersShowcase onRequest={handleRequest} />
        <Gallery />
        <LeadCapture
          presetInterest={leadContext.interest}
          presetOfferId={leadContext.offerId}
          presetOfferTitle={leadContext.offerTitle}
        />
        <FounderNote />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
